/* Mad Dog 357 motion + UX touches (Andrew 2026-09-16). Native Web Animations API, no library.
   Loaded (defer) from snippets/md-promo-head.liquid. Animations are skipped under "reduce motion";
   the sticky bar and heat meters still work without animation. */
(function () {
  'use strict';
  var RM = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var anim = function (el, frames, opts) { if (!RM && el && el.animate) return el.animate(frames, opts); return null; };
  var onVisible = function (el, cb, threshold) {
    if (!('IntersectionObserver' in window)) { cb(); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) { io.disconnect(); cb(); } });
    }, { threshold: threshold || 0.3 });
    io.observe(el);
  };

  /* Cart icon + count bump whenever the cart updates */
  function cartBump() {
    var icon = document.getElementById('cart-icon-bubble');
    if (!icon || !window.MutationObserver) return;
    var t;
    new MutationObserver(function () {
      clearTimeout(t);
      t = setTimeout(function () {
        anim($('.cart-count-bubble', icon), [{ transform: 'scale(1)' }, { transform: 'scale(1.35)' }, { transform: 'scale(1)' }], { duration: 420, easing: 'cubic-bezier(.34,1.56,.64,1)' });
        anim($('svg', icon), [{ transform: 'scale(1)' }, { transform: 'scale(1.15) rotate(-8deg)' }, { transform: 'scale(1)' }], { duration: 420, easing: 'cubic-bezier(.34,1.56,.64,1)' });
      }, 40);
    }).observe(icon, { childList: true, subtree: true, characterData: true });
  }

  /* One drop falls from the tapped Add to cart button into the cart icon (real taps only) */
  function dropToCart() {
    document.addEventListener('click', function (e) {
      if (RM || !e.isTrusted || !e.target || !e.target.closest) return;
      var b = e.target.closest('.product-form__submit, .quick-add__submit, .md-sticky-atc__btn');
      if (!b || b.disabled || b.getAttribute('aria-disabled') === 'true') return;
      var icon = document.getElementById('cart-icon-bubble');
      if (!icon || !document.body.animate) return;
      var a = b.getBoundingClientRect(), c = icon.getBoundingClientRect();
      var x0 = a.left + a.width / 2, y0 = a.top + a.height / 2;
      var dx = c.left + c.width / 2 - x0, dy = c.top + c.height / 2 - y0;
      var d = document.createElement('span');
      d.className = 'md-drop';
      d.style.left = (x0 - 7) + 'px';
      d.style.top = (y0 - 7) + 'px';
      document.body.appendChild(d);
      var lift = dy * 0.55 - 70;
      var done = function () { if (d.parentNode) d.parentNode.removeChild(d); };
      var p = d.animate([
        { transform: 'translate(0px, 0px) rotate(45deg) scale(1)', opacity: 1 },
        { transform: 'translate(' + Math.round(dx * 0.45) + 'px, ' + Math.round(lift) + 'px) rotate(45deg) scale(1.1)', opacity: 1, offset: 0.45 },
        { transform: 'translate(' + Math.round(dx) + 'px, ' + Math.round(dy) + 'px) rotate(45deg) scale(0.35)', opacity: 0.2 }
      ], { duration: 750, easing: 'cubic-bezier(.45,0,.55,1)', fill: 'forwards' });
      p.onfinish = done;
      p.oncancel = done;
      setTimeout(done, 1200);
    }, true);
  }

  /* Heat Scale slider: no glide lag while dragging, glow rises with the heat, panel eases in */
  function heatSlider() {
    var root = $('.md-slider');
    if (!root) return;
    var down = false;
    var start = function () { down = true; };
    var move = function () { if (down) root.classList.add('md-dragging'); };
    var end = function () { down = false; root.classList.remove('md-dragging'); };
    root.addEventListener('mousedown', start);
    root.addEventListener('touchstart', start, { passive: true });
    window.addEventListener('mousemove', move);
    window.addEventListener('touchmove', move, { passive: true });
    window.addEventListener('mouseup', end);
    window.addEventListener('touchend', end);
    var fill = $('.md-slider__track-fill', root), thumb = $('.md-slider__thumb', root);
    var name = $('.md-slider__panel-name', root), left = $('.md-slider__panel-left', root), img = $('.md-slider__panel-image', root);
    var glow = function () {
      if (!fill || !thumb) return;
      var c = fill.style.backgroundColor || getComputedStyle(fill).backgroundColor;
      var r = Math.round(6 + (parseFloat(fill.style.width) || 0) * 0.16);
      root.style.setProperty('--md-heat-glow', c);
      root.style.setProperty('--md-heat-r', r + 'px');
      thumb.style.boxShadow = '0 0 ' + r + 'px ' + Math.round(r / 3) + 'px ' + c;
    };
    glow();
    if (fill) new MutationObserver(glow).observe(fill, { attributes: true, attributeFilter: ['style'] });
    if (name) new MutationObserver(function () {
      [left, img].forEach(function (el) { anim(el, [{ opacity: 0.35, transform: 'translateY(6px)' }, { opacity: 1, transform: 'none' }], { duration: 380, easing: 'cubic-bezier(.22,1,.36,1)' }); });
    }).observe(name, { childList: true, characterData: true, subtree: true });
  }

  /* Sticky Add to cart bar on phones, shown once the real button has scrolled above the screen */
  function stickyATC() {
    var info = $('.product__info-container');
    var btn = info ? $('.product-form__submit', info) : null;
    if (!btn || !window.matchMedia) return;
    var mq = window.matchMedia('(max-width: 749px)');
    var titleEl = $('.product__title h1', info);
    var bar = document.createElement('div');
    bar.className = 'md-sticky-atc';
    bar.setAttribute('aria-hidden', 'true');
    bar.innerHTML = '<div class="md-sticky-atc__info"><span class="md-sticky-atc__title"></span><span class="md-sticky-atc__price"></span></div><button type="button" class="md-sticky-atc__btn button button--primary" tabindex="-1"></button>';
    var bTitle = $('.md-sticky-atc__title', bar), bPrice = $('.md-sticky-atc__price', bar), bBtn = $('.md-sticky-atc__btn', bar);
    bTitle.textContent = titleEl ? titleEl.textContent.trim() : '';
    var sync = function () {
      var promo = $('.price.md-promo-price', info) && !document.documentElement.classList.contains('md-promo-off');
      var now = $('.md-promo-price__now', info), was = $('.md-promo-price__was', info);
      bPrice.textContent = '';
      if (promo && now) {
        var n = document.createElement('span'); n.className = 'md-sticky-atc__now'; n.textContent = now.textContent.trim(); bPrice.appendChild(n);
        if (was) { var s = document.createElement('s'); s.textContent = was.textContent.trim(); bPrice.appendChild(s); }
      } else {
        var reg = $('.price--on-sale .price-item--last', info) || $('.price__regular .price-item--regular', info);
        bPrice.textContent = reg ? reg.textContent.trim() : '';
      }
      var label = $('span', btn);
      bBtn.textContent = ((label ? label.textContent : btn.textContent) || '').trim() || 'Add to cart';
      bBtn.disabled = !!btn.disabled;
    };
    sync();
    new MutationObserver(sync).observe(info, { subtree: true, childList: true, characterData: true, attributes: true, attributeFilter: ['disabled'] });
    document.body.appendChild(bar);
    bBtn.addEventListener('click', function () { if (!btn.disabled) btn.click(); });
    var render = function () {
      var past = btn.getBoundingClientRect().bottom < 0;
      var blocked = document.querySelector('.cart-notification.active, cart-drawer.active, details.menu-drawer-container[open]');
      var show = past && mq.matches && !blocked;
      bar.classList.toggle('is-visible', show);
      bar.setAttribute('aria-hidden', show ? 'false' : 'true');
      bBtn.tabIndex = show ? 0 : -1;
      document.body.classList.toggle('md-sticky-on', show);
    };
    var ticking = false;
    window.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () { ticking = false; render(); });
    }, { passive: true });
    window.addEventListener('resize', render);
    var cn = $('.cart-notification');
    if (cn) new MutationObserver(render).observe(cn, { attributes: true, attributeFilter: ['class'] });
    var md = $('details.menu-drawer-container');
    if (md) new MutationObserver(render).observe(md, { attributes: true, attributeFilter: ['open'] });
    render();
  }

  /* Heat meter fallback for product tiles that don't already show the theme's own heat pips */
  function heatMeters(scope) {
    var map = window.mdHeat;
    if (!map) return;
    $$('.card-wrapper:not([data-md-heat])', scope).forEach(function (w) {
      w.setAttribute('data-md-heat', '1');
      if ($('.md-card-shu', w)) return;
      var a = $('a[href*="/products/"]', w);
      if (!a) return;
      var handle = decodeURIComponent(((a.pathname || '').split('/products/')[1] || '').split('/')[0]);
      var shu = map[handle];
      if (!shu) return;
      var hosts = $$('.card-information', w);
      var host = hosts[hosts.length - 1];
      if (!host) return;
      var lvl = Math.max(1, Math.min(5, Math.ceil((Math.log(shu) / Math.LN10 - 5) / (Math.log(9e6) / Math.LN10 - 5) * 5)));
      var label = shu >= 1e6 ? (Math.round(shu / 1e4) / 100) + 'M' : Math.round(shu / 1e3) + 'K';
      var el = document.createElement('div');
      el.className = 'md-heat md-heat--' + lvl;
      el.setAttribute('role', 'img');
      el.setAttribute('aria-label', 'Heat level ' + lvl + ' of 5, ' + shu.toLocaleString('en-US') + ' Scoville heat units');
      el.innerHTML = '<span class="md-heat__bars" aria-hidden="true"><i></i><i></i><i></i><i></i><i></i></span><span class="md-heat__shu" aria-hidden="true">' + label + ' SHU</span>';
      host.appendChild(el);
      if (!RM) {
        el.classList.add('md-heat--pre');
        onVisible(el, function () { el.classList.remove('md-heat--pre'); }, 0.6);
      }
    });
  }

  /* Headlines punch in word by word (only ones below the fold, so nothing flickers on load) */
  function headlines() {
    if (RM || !('IntersectionObserver' in window)) return;
    $$('main h1, main h2').forEach(function (h) {
      if (h.children.length || h.closest('.rte, .product, .card-wrapper, .jdgm-rev-widg, .md357-master, .cart__items, .shopify-policy__container, .md-promo-banner, .article-template')) return;
      var text = h.textContent.replace(/\s+/g, ' ').trim();
      if (text.length < 3 || text.length > 90) return;
      if (h.getBoundingClientRect().top < window.innerHeight) return;
      h.setAttribute('aria-label', text);
      h.innerHTML = text.split(' ').map(function (w, i) {
        var safe = w.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
        return '<span class="md-word" aria-hidden="true" style="--i:' + i + '">' + safe + '</span>';
      }).join(' ');
      h.classList.add('md-words');
      onVisible(h, function () { h.classList.add('is-in'); }, 0.4);
    });
  }

  /* Review stars fill in one by one when they come into view */
  function stars() {
    if (RM) return;
    $$('.jdgm-prev-badge__stars:not([data-md-stars]), .jdgm-rev-widg__summary-stars:not([data-md-stars])').forEach(function (s) {
      var list = $$('.jdgm-star', s);
      if (!list.length) return;
      s.setAttribute('data-md-stars', '1');
      onVisible(s, function () {
        list.forEach(function (st, i) {
          anim(st, [{ opacity: 0.15, transform: 'scale(.4)' }, { opacity: 1, transform: 'scale(1.2)', offset: 0.6 }, { opacity: 1, transform: 'scale(1)' }], { duration: 450, delay: i * 90, easing: 'ease-out', fill: 'backwards' });
        });
      }, 0.6);
    });
  }

  /* Free-shipping meter: fill grows in, burst of embers when it hits $75 */
  function shipMeter() {
    var sec = $('.md-ship');
    if (!sec) return;
    var host = sec.parentElement || sec;
    var last = null;
    var burst = function (fill) {
      anim($('.md-ship__msg', host), [{ transform: 'scale(1)' }, { transform: 'scale(1.08)' }, { transform: 'scale(1)' }], { duration: 500, easing: 'cubic-bezier(.34,1.56,.64,1)' });
      if (RM) return;
      var track = fill.parentElement;
      for (var i = 0; i < 10; i++) {
        var e = document.createElement('span');
        e.className = 'md-ember';
        track.appendChild(e);
        var ang = (i / 10) * Math.PI * 2, dist = 18 + (i % 3) * 10;
        var pl = e.animate([{ transform: 'translate(0px, 0px) scale(1)', opacity: 1 }, { transform: 'translate(' + Math.round(Math.cos(ang) * dist) + 'px, ' + Math.round(Math.sin(ang) * dist - 10) + 'px) scale(.3)', opacity: 0 }], { duration: 700 + (i % 4) * 80, easing: 'cubic-bezier(.22,1,.36,1)', fill: 'forwards' });
        var rm = (function (el) { return function () { if (el.parentNode) el.parentNode.removeChild(el); }; })(e);
        pl.onfinish = rm;
        setTimeout(rm, 1400);
      }
    };
    var check = function (first) {
      var fill = $('.md-ship__fill', host);
      if (!fill) return;
      var w = parseFloat(fill.style.width) || 0;
      if (first && w > 0) anim(fill, [{ width: '0%' }, { width: w + '%' }], { duration: 900, easing: 'cubic-bezier(.22,1,.36,1)' });
      if (last !== null && last < 100 && w >= 100) burst(fill);
      last = w;
    };
    check(true);
    new MutationObserver(function () { check(false); }).observe(host, { subtree: true, childList: true, attributes: true, attributeFilter: ['style'] });
  }

  /* Desktop menu: hover Shop to open it, hover a category to pop its products out to the right.
     Short delays so the menu doesn't snap shut when the mouse cuts a corner. Clicks still work as before. */
  function menuFlyouts() {
    var nav = $('.header__inline-menu');
    if (!nav || !window.matchMedia) return;
    var mq = window.matchMedia('(min-width: 990px) and (hover: hover)');
    var all = $$('details', nav);
    var tops = all.filter(function (d) { return !d.parentElement.closest('.header__submenu'); });
    var subs = all.filter(function (d) { return !!d.parentElement.closest('.header__submenu'); });
    var setOpen = function (d, on) {
      if (on) d.setAttribute('open', ''); else d.removeAttribute('open');
      var s = d.querySelector('summary');
      if (s) s.setAttribute('aria-expanded', on ? 'true' : 'false');
      if (!on) $$('details[open]', d).forEach(function (x) { setOpen(x, false); });
    };
    tops.forEach(function (d) {
      var li = d.closest('li') || d.parentElement;
      var t;
      li.addEventListener('mouseenter', function () {
        if (!mq.matches) return;
        clearTimeout(t);
        tops.forEach(function (o) { if (o !== d && o.hasAttribute('open')) setOpen(o, false); });
        if (!d.hasAttribute('open')) setOpen(d, true);
      });
      li.addEventListener('mouseleave', function () {
        if (!mq.matches) return;
        t = setTimeout(function () { setOpen(d, false); }, 300);
      });
    });
    subs.forEach(function (d) {
      var li = d.parentElement;
      var t, s;
      li.addEventListener('mouseenter', function () {
        if (!mq.matches) return;
        clearTimeout(t);
        var list = d.closest('.header__submenu');
        var other = subs.filter(function (o) { return o !== d && o.hasAttribute('open') && o.closest('.header__submenu') === list; })[0];
        var go = function () { if (other) setOpen(other, false); setOpen(d, true); };
        if (other) s = setTimeout(go, 150); else go();
      });
      li.addEventListener('mouseleave', function () {
        if (!mq.matches) return;
        clearTimeout(s);
        t = setTimeout(function () { setOpen(d, false); }, 350);
      });
    });
  }

  function init() {
    try { cartBump(); } catch (e) {}
    try { dropToCart(); } catch (e) {}
    try { heatSlider(); } catch (e) {}
    try { stickyATC(); } catch (e) {}
    try { heatMeters(document); } catch (e) {}
    try { headlines(); } catch (e) {}
    try { stars(); setTimeout(stars, 1500); setTimeout(stars, 4000); } catch (e) {}
    try { shipMeter(); } catch (e) {}
    try { menuFlyouts(); } catch (e) {}
    try {
      $$('#ProductGridContainer, product-recommendations, .collection').forEach(function (n) {
        var t;
        new MutationObserver(function () { clearTimeout(t); t = setTimeout(function () { heatMeters(n); stars(); }, 60); }).observe(n, { childList: true, subtree: true });
      });
    } catch (e) {}
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
